import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ppaUrls } from 'config/urls';

type PerformanceFeature = {
    feature_id: string;
    feature_name?: string;
    feature_type?: string;
    options?: {
        tabs?: any[];
        tiles?: any[];
    };
    tiles?: any[];
};

type PerformanceSummaryMetaResponse = {
    title?: string;
    features?: PerformanceFeature[];
};

const usePerformanceSummaryMeta = () => {
    const { data: performanceSummaryMeta, isLoading, isPending } = useQuery<PerformanceSummaryMetaResponse>({
        queryKey: ['performance-summary-meta'],
        queryFn: async () => {
            const response = await axios.get(ppaUrls.getPerformanceSummaryMetaUrl);
            return response.data;
        },
    });

    return { performanceSummaryMeta, isLoading, isPending };
};

export type { PerformanceFeature, PerformanceSummaryMetaResponse };
export default usePerformanceSummaryMeta;
